import React, { useEffect } from 'react';

import { Card } from '../../common/Card';

import { MyProfileForm } from './MyProfileForm';
import { usePageTitle } from '../../PageTitleContext';

type MyProfileProps = {};

export function MyProfile({}: MyProfileProps) {
  const { setPageTitle } = usePageTitle();

  useEffect(() => {
    setPageTitle('My Profile');
  }, []);

  return (
    <Card
      style={{ padding: 20, width: 350, alignSelf: 'center', margin: '0 auto' }}
    >
      <h2>My Profile</h2>
      <MyProfileForm />
    </Card>
  );
}
